const ChartLastDot = ({ props, data, dataKey }: { props: any; data: any; dataKey: string }) => {
  const isLastPoint = props.index === data.length - 1;
  if (!isLastPoint) return <circle />;

  return <circle cx={props.cx} cy={props.cy} r={3.5} stroke={`var(--color-${dataKey})`} strokeWidth={2} fill="white" />;
};

export { ChartLastDot };
